import {Component, OnInit} from '@angular/core';
import {PreviewDataSourceInfo} from '../../../models/preview-data-source-info.model';
import {ColumnsType} from '../../../models/columns-type.model';
import {Subscription} from 'rxjs';
import {NbDialogRef} from '@nebular/theme';
import {DataSourceFacade} from '../../../facade/data-source.facade';

@Component({
    selector: 'morva-confirmation-replacement',
    templateUrl: './confirmation-replacement.component.html',
    styleUrls: ['./confirmation-replacement.component.scss'],
})
export class ConfirmationReplacementComponent implements OnInit {
    oldDataSourceName: string;
    previewDataSourceInfo: Partial<PreviewDataSourceInfo>;
    columnsTypes: ColumnsType;
    workspaceId: string;
    sheetName: string;
    isUpdating: boolean;
    dataSourceWarnings: string[];
    subscriptions: Subscription[] = [];

    constructor(private dialogRef: NbDialogRef<any>,
                private dataSourceFacade: DataSourceFacade) {
    }

    ngOnInit(): void {
        this.setSubscribers();
    }

    setSubscribers(): void {
        this.subscriptions.push(this.dataSourceFacade.getSubmitState$().subscribe((submit) => {
            if(submit === 'submitted') {
                this.isUpdating = false;
                this.dataSourceFacade.setSubmitState('notSubmitted');
                this.closeDialog(true);
            } else if (submit === 'notSubmitted') {
                this.isUpdating = false;
            }
        }));
    }

    closeDialog(isReplaced: boolean = false): void {
        this.dialogRef.close(isReplaced);
    }

    onSubmitAlert(): void {
        this.isUpdating = true;
        this.dataSourceFacade.createReplacementTable(this.previewDataSourceInfo, this.workspaceId,
            this.columnsTypes, this.sheetName);
    }
}
